module.exports = __webpack_public_path__ + "img/Industrial Insights Report.4d7402ba.jpg";